import { AbstractControl, ValidationErrors } from '@angular/forms';

export interface PasswordRule {
  key: string;
  label: string;
  test: (value: string) => boolean;
}

const MIN_DIGITS = 4;

export const PASSWORD_RULES: readonly PasswordRule[] = [
  { key: 'lowercase', label: 'Ao menos 1 letra minúscula', test: v => /[a-z]/.test(v) },
  { key: 'uppercase', label: 'Ao menos 1 letra maiúscula', test: v => /[A-Z]/.test(v) },
  { key: 'special', label: 'Ao menos 1 caractere especial', test: v => /[^A-Za-z0-9\s]/.test(v) },
  { key: 'digits', label: `Ao menos ${MIN_DIGITS} números`, test: v => (v.match(/\d/g) ?? []).length >= MIN_DIGITS }
];

// Vazio fica a cargo do Validators.required.
export function strongPasswordValidator(control: AbstractControl): ValidationErrors | null {
  const value: string = control.value ?? '';
  if (!value) return null;
  return PASSWORD_RULES.every(rule => rule.test(value)) ? null : { weakPassword: true };
}
